import { ContainerModule, interfaces } from 'inversify';
import { AddMarkingToolBl, AddMarkingToolBlImpl } from './AddMarkingTool.bl';
import { AddMarkingToolStoreImpl, IAddMarkingToolStore } from './AddMarkingTool.store';
import { AddMarkingToolApiServiceImpl, IAddMarkingToolApiService } from './services/AddMarkingToolApi.service';

export const addMarkingToolModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IAddMarkingToolStore.$).to(AddMarkingToolStoreImpl).inSingletonScope();
  bind(AddMarkingToolBl.$).to(AddMarkingToolBlImpl).inSingletonScope();
  bind(IAddMarkingToolApiService.$).to(AddMarkingToolApiServiceImpl).inSingletonScope();
});
